import { type PropsWithChildren } from "react";

import { Footer } from "@vega-core/components/Layout/Footer/Footer";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";

import { AuthHeader } from "../../../Auth/components/AuthHeader";
import { PublicConfigBanner } from "../../../ConfigBanner/PublicConfigBanner";
import { getLPLoginFaqItems } from "../lpLoginFaq";
import { useCmsLoginFaqs } from "../useCmsLoginFaqs";

import { Banner, type BannerItem } from "./Banner";

type Props = PropsWithChildren<{
  bannerItems?: BannerItem[];
  headerTitle?: string;
}>;

export const LoginLayout = ({ children, bannerItems, headerTitle }: Props) => {
  const {
    contacts: { helpEmail },
    global: { companyName },
  } = usePublicConfig();
  const faqItems = useCmsLoginFaqs(getLPLoginFaqItems(helpEmail, companyName));

  return (
    <div className="min-h-dvh flex flex-col bg-background/auth/primary">
      <PublicConfigBanner />
      <div className="flex flex-1 gap-8 xl:gap-12 p-4 xl:p-12">
        <div className="hidden md:flex md:w-56 lg:w-80 xl:w-1/2 justify-center items-center bg-background/auth/secondary rounded-lg max-h-[calc(100dvh-theme(spacing.4)*2)] xl:max-h-[calc(100vh-theme(spacing.12)*2)] overflow-hidden">
          <Banner items={bannerItems} />
        </div>
        <div className="flex-1 flex flex-col bg-background/auth/primary">
          <AuthHeader faqItems={faqItems} title={headerTitle} />
          <div className="flex flex-grow w-full flex-col justify-center  items-center">
            <div className="w-full max-w-lg md:max-w-xl h-full text-text/auth/secondary">
              {children}
            </div>
          </div>
          <Footer
            containerStyle="p-0"
            isLoggedIn={false}
            linkClassName="hover:text-text/auth/primary"
          />
        </div>
      </div>
    </div>
  );
};
